import { CityDetailsResponse } from '@/core/domain/city-details/models/city-details.model';
import { CityDetailsRepository } from '@/core/domain/city-details/repositories/city-details.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CityDetailsImplRepository extends CityDetailsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getCityDetails(url: string): Observable<CityDetailsResponse> {
        return this.httpClient
            .get<CityDetailsResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.cityDetails,
                    url,
                ].join('/'),
            )
            .pipe(
                switchMap((cityDetailsResponse: CityDetailsResponse) => {
                    const cityDetails: CityDetailsResponse = {
                        type: cityDetailsResponse.type,
                        action: cityDetailsResponse.action,
                        notifications: cityDetailsResponse.notifications,
                        data: cityDetailsResponse.data,
                    };

                    return of(cityDetails);
                }),
            );
    }
}
